<template>
    <div class="app-bottom-nav">
        <div class="app-bottom-nav__inner">
            <div class="container">
                <template v-for="link in headerLinks">
                    <!-- 动态路由 -->
                    <router-link v-if="link.type==='dynamic'"
                                 class="app-bottom-nav__nav-link"
                                 :class="{
                                    active:routeName===link.routeName
                                 }"
                                 :key="link.slug"
                                 :to="{ name: link.routeName, params: { section: link.slug } }">
                        <app-icon :value="link.icon"/>
                        <span>{{link.name}}</span>
                    </router-link>
                    <!-- 静态路由 -->
                    <router-link v-else-if="link.type === 'static'"
                                 class="app-bottom-nav__nav-link"
                                 :class="{
                                    active:routeName===link.slug
                                 }"
                                 :key="link.slug"
                                 :to="{ name: link.slug }"
                    >
                        <app-icon :value="link.icon"/>
                        <span>{{link.name}}</span>
                    </router-link>
                    <!-- 外部路由 -->
                    <a v-else-if="link.type === 'external'"
                       class="app-bottom-nav__nav-link"
                       :key="link.href"
                       :href="link.href">
                        <app-icon :value="link.icon"/>
                        <span>{{link.name}}</span>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {HEADER_LINKS} from '@config'
    import AppIcon from '@components/AppIcon'

    export default {
        name: 'AppBottomNav',
        data() {
            return {
                headerLinks: HEADER_LINKS,
            }
        },
        computed: {
            routeName() {
                const route = this.$route
                return route.name
            }
        },
        components: {
            AppIcon
        },
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-bottom-nav {
        display: none;
        height: $headerHeight;
        padding-bottom: env(safe-area-inset-bottom);

        &__inner {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 999;
            height: $headerHeight;
            box-sizing: content-box;
            box-shadow: 0 0 8px rgba(0,0,0,.101562);
            // border-top: 1px solid $borderColor;
            // border-color: var(--borderColor);
            background-color: $backgroundColor;
            background-color: var(--backgroundColor);
            padding-bottom: env(safe-area-inset-bottom);
            @include transition-colors;

            .container {
                display: flex;
                justify-content: space-between;
                height: 100%;
            }

        }

        &__nav-link {
            flex: 1;
            padding: $paddingBase;
            font-size: $fontSizeCommon;
            text-align: center;
            box-sizing: border-box;
            height: 100%;
            color: $textColor;
            color: var(--textColor);
            @include transition-colors;

            &.active {
                color: $primaryColor;
                color: var(--primaryColor);
                .app-icon{
                    color: $primaryColor;
                    color: var(--primaryColor);
                }
            }

            .app-icon {
                font-size: $fontSizeMD;
                display: inline-block;
                @include transition-colors;
            }

            span {
                display: block;
            }
        }
    }

    @media (max-width: 860px) {
        .app-bottom-nav {
            display: block;
        }
    }
</style>